/** Helpers étiquettes aligneurs (fiche production). */

const MAX_LABELS = 200;

export function getLocalDateInputValue(date = new Date()) {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) return '';
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function hasPackagingDate(packagingDate) {
  return Boolean(String(packagingDate || '').trim());
}

/**
 * Nombre d'étiquettes depuis la plage Étiquette De → À (inclus).
 */
export function computeLabelPrintCount(form) {
  const from = Number(form?.label_from);
  const to = Number(form?.label_to);
  if (!Number.isFinite(from) || !Number.isFinite(to) || to < from) return 0;
  return Math.min(Math.floor(to - from + 1), MAX_LABELS);
}

/** Numéros d'aligneurs à imprimer (De → À). */
export function listAlignerLabelNumbers(form) {
  const from = Number(form?.label_from);
  const count = computeLabelPrintCount(form);
  if (count <= 0) return [];
  return Array.from({ length: count }, (_, i) => from + i);
}

/**
 * Date d'expiration = date d'emballage + 3 ans.
 * @param {string|Date|null|undefined} packagingDate
 * @returns {Date|null}
 */
export function computeExpiryDateFromPackaging(packagingDate) {
  if (!packagingDate) return null;
  const d = packagingDate instanceof Date ? new Date(packagingDate) : new Date(packagingDate);
  if (Number.isNaN(d.getTime())) return null;
  const expiry = new Date(d);
  expiry.setFullYear(expiry.getFullYear() + 3);
  return expiry;
}

export function formatLabelDateFr(date) {
  if (!date || Number.isNaN(date.getTime?.() ?? NaN)) return null;
  return date.toLocaleDateString('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
}
